export const ITEM_CLICK_SOUNDS = [
  "/sounds/ItemClick01.mp3",
  "/sounds/ItemClick02.mp3",
  "/sounds/ItemClick03.mp3",
  "/sounds/ItemClick04.mp3",
  "/sounds/ItemClick05.mp3",
  "/sounds/ItemClick06.mp3",
  "/sounds/ItemClick07.mp3",
  "/sounds/ItemClick08.mp3",
  "/sounds/ItemClick09.mp3",
];

export const ITEM_DROP_SOUND = "/sounds/ItemClick09.mp3";

export const playItemClickSound = (): void => {
  const src = ITEM_CLICK_SOUNDS[Math.floor(Math.random() * ITEM_CLICK_SOUNDS.length)];
  playSound(src);
};

export const playItemDropSound = (): void => {
  playSound(ITEM_DROP_SOUND);
};

const playSound = (src: string): void => {
  const audio = new Audio(src);
  audio.volume = 0.5;
  void audio.play().catch(() => undefined);
};
